import Lenis from "@studio-freight/lenis"
export const lenis = new Lenis({
    lerp: .2,
})

const menuContainer = document.querySelector('[data-js="menu-slider"]');
export const menuLenis = new Lenis({
    wrapper: menuContainer,
    lerp: .2,
})

export default function initLenis() {

    function raf(time) {
        lenis.raf(time)
        menuLenis.raf(time)
        requestAnimationFrame(raf)
    }

    requestAnimationFrame(raf)
}